export const carOptionsTypes = Object.freeze({
  SET_CAR_OPTIONS: 'SET_CAR_OPTIONS',
  SET_CAR_SELECTED_OPTION: 'SET_CAR_SELECTED_OPTION',
  SET_USER_MADE_ORDER: ' SET_USER_MADE_ORDER'
})
